import React from "react";
import { NavLink } from "react-router-dom";
import BannerImage2 from "../../assets/images/about-us/about-banner.png";
const BannerSection = () => {
  return (
    <>
      <section className="topPageBanner _border-bottom" id="home">
        <div className="max-container">
          <div className="padd-90">
            <div className="grid-auto-fit align-items-center">
              <div>
                <h1 className="heading39px roboto-regular mb20">
                  <span className="roboto-bold">ABOUT</span> US!
                </h1>
                <p className="roboto-regular heading16px mb10">
                  BeyondLeadz is an AI-powered sales and marketing automation platform built specifically for the hospitality industry. We enable hotels, resorts, and travel businesses to streamline lead generation, manage guest interactions, and run hyper-personalized campaigns with ease.
                </p>

                <p className="roboto-regular heading16px mb30">
                  By combining intelligent automation, real-time data, and deep industry insights, BeyondLeadz helps hospitality brands drive more bookings, enhance guest engagement, and stay ahead in a competitive market.
                </p>

                <ul className="btn-sec">
                  <li>
                    <NavLink
                      to={"/signup"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      {" "}
                      Start Free Trial
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={"/contact-us"}
                      className="common-btn-class transparentBtn roboto-regular"
                    >
                      Contact us
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div className="text-center">
                <img
                  src={BannerImage2}
                  className="img-responsive position-relative"
                  alt="About Us"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-sec-content position-relative">
        <div className="max-container">
          <div className="padd-90">
            <p className="roboto-regular heading16px text-color-131415 mb20">
              <em> Go Beyond</em>
            </p>

            <p className="roboto-regular heading16px text-color-131415 mb20">
              <strong> BeyondLeadz goes far beyond traditional lead generation—it's a complete growth and engagement engine for the hospitality sector.</strong> Developed by <strong>hospitality industry experts with deep experience in sales and marketing,</strong> BeyondLeadz is built to solve real-world challenges faced by hotels, resorts, and travel businesses. From managing guest reviews and automating personalized messages to organizing your sales calendar with AI and tracking guest interactions in real-time, the platform combines smart automation with actionable insights to help you elevate every stage of the guest journey. With BeyondLeadz, your team stays connected, responsive, and always one step ahead.
            </p>

          </div>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#d3e4fe"
            fill-opacity="0.8"
            d="M0,288L48,288C96,288,192,288,288,288C384,288,480,288,576,288C672,288,768,288,864,240C960,192,1056,96,1152,64C1248,32,1344,64,1392,80L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </section>
    </>
  );
};
export default BannerSection;
